export default __webpack_public_path__ + "static/media/logo.b76567e7.png";